module.exports = __webpack_public_path__ + "static/media/Product_Management.78dbcf7c.jpg";